"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HitTestableGroup = void 0;
const a_entity_group_1 = require("./a-entity-group");
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc IHitTestableGroup}
 */
class HitTestableGroup extends a_entity_group_1.AEntityGroup {
    constructor(argProvider, plot) {
        super();
        this.argProvider = argProvider;
        this.plot = plot;
        this.entitiesByHitTester = new Map();
        this.hitTesterByEntity = new WeakMap();
        this.referenceCounts = new WeakMap();
        this.isDirty = true;
        this.entitiesInGroup = new Set();
        this.cache = [];
    }
    getHitTester(entity) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.hitTesterByEntity.has(entity), "expected to find hit test component");
        return this.hitTesterByEntity.get(entity);
    }
    getEntitiesByHitTester() {
        if (this.isDirty) {
            this.isDirty = false;
            return this.cache = rc_js_util_1._Map.arrayMap(this.entitiesByHitTester, (entities, hitTester) => {
                return [hitTester, entities.getArray()];
            });
        }
        else {
            return this.cache;
        }
    }
    refCountingAddEntity(entity, options) {
        var _a;
        const count = 1 + ((_a = this.referenceCounts.get(entity)) !== null && _a !== void 0 ? _a : 0);
        this.referenceCounts.set(entity, count);
        if (count > 1) {
            DEBUG_MODE && rc_js_util_1._Debug.assert(this.hitTesterByEntity.get(entity) === options.hitTestComponent, "attempted to set a different hit test component to one previous set");
            return;
        }
        this.plot.addToGroup(entity, this, options);
    }
    refCountingRemoveEntity(entity) {
        var _a;
        const count = (_a = this.referenceCounts.get(entity)) !== null && _a !== void 0 ? _a : 0;
        // decrementing will result in empty
        if (count === 1) {
            this.plot.removeFromGroup(entity, this);
            this.referenceCounts.delete(entity);
        }
        else {
            this.referenceCounts.set(entity, count - 1);
        }
    }
    onEntityAdded(entity, options) {
        rc_js_util_1.DirtyCheckedUniqueCollection.mapInitializeAdd(this.entitiesByHitTester, options.hitTestComponent, entity);
        this.hitTesterByEntity.set(entity, options.hitTestComponent);
        this.entitiesInGroup.add(entity);
        this.isDirty = true;
    }
    onEntityRemoved(entity) {
        const hitTesters = this.hitTesterByEntity.get(entity);
        if (hitTesters != null) {
            this.hitTesterByEntity.delete(entity);
            rc_js_util_1._Map.clearingDeleteFromSet(this.entitiesByHitTester, hitTesters, entity);
            this.entitiesInGroup.delete(entity);
            this.isDirty = true;
        }
    }
}
exports.HitTestableGroup = HitTestableGroup;
//# sourceMappingURL=hit-testable-group.js.map